import React, { useState, useEffect } from 'react';
import { getData, postData } from '../../../../../ApiServices/ApiService';
import {
    ORG_GET_GROUP_LIST, ORG_CLIENT_SEARCH_TO_ADD_GROUPMEMBER, ORG_INVOICE_SUMMARY_REPORT, ORG_RECEIPT_SUMMARY_REPORT,
    ORG_INVOICE_REGISTER_REPORT, ORG_RECEIPT_REGISTER_REPORT, ORG_ESTIMATE_REGISTER_REPORT, ORG_UNBILLED_TASK_REPORT, ORG_FREE_TASK_REPORT
} from '../../../../../ApiServices/BaseURL';

import { logFrontendException } from '../../../../../Utils/Exception';
import { useTheme } from '../../../../../GlobalContext/GlobalContext';

const InvoiceReportsController = () => {
    const [reportName, setReportName] = useState(null);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [reportNameError, setReportNameError] = useState("");
    const [startDateError, setStartDateError] = useState("");
    const [endDateError, setEndDateError] = useState("");
    const [generateReportError, setGenerateReportError] = useState("");
    const [generateReportSuccess, setGenerateReportSuccess] = useState("");
    const [generateReportLoading, setGenerateReportLoading] = useState(false);

    const [searchClient, setSearchClient] = useState('');
    const [clientError, setClientError] = useState('');
    const [clientList, setClientList] = useState([]);
    const [clientSearchError, setClientSearchError] = useState('');
    const [clientListLoading, setClientListLoading] = useState(false);
    const [selectedClient, setSelectedClient] = useState(null);

    const [groupClientOptionsList, setGroupClientOptionsList] = useState([]);
    const [groupLoading, setGroupLoading] = useState(false)
    const [groupClientError, setGroupClientError] = useState('');
    const [groupClient, setGroupClient] = useState(null);

    const pageName = 'InvoiceReportsController';
    const storedUserId = JSON.parse(localStorage.getItem("_userInfo_"))?.emp_id;
    const { setIsLoginPopup } = useTheme();

    const [invoiceReportOptions,setInvoiceReportOptions] = useState([])


    const filteredInvoiceReportOptions = [
        { label: "Receipt Summary", value: "receipt_summary_report" },
        { label: "Invoice Summary", value: "invoice_summary_report" },
        { label: "Receipt Register", value: "receipt_register_report" },
        { label: "Invoice Register", value: "invoice_register_report" },
        { label: "Estimate Register", value: "estimate_register_report" },
        { label: "Unbilled Task Report", value: "unbilled_task_report" },
        { label: "Free Task Report", value: "free_task_report" }
    ];

    // Mapping between per_name_sub_json keys and option values
    const reportPermissionMap = {
        "rcpt_summary": "receipt_summary_report",
        "inv_summary": "invoice_summary_report",
        "recpt_register": "receipt_register_report",
        "inv_register": "invoice_register_report",
        "estimate_register": "estimate_register_report",
        "unbilled_task_report": "unbilled_task_report",
        "free_task_report": "free_task_report"
    };


      const [userPermissions, setUserPermissions] = useState(null);
  useEffect(() => {
    const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
    setUserPermissions(storedUserInfo?.user_permissions || {});
  }, [])

  useEffect(()=>{
    if(userPermissions){
        console.log('userPermissions',userPermissions)
            // Filter based on permission values
    const invoiceReportOptionsFiltered = filteredInvoiceReportOptions.filter(option => {
        const permissionKey = Object.keys(reportPermissionMap).find(key => reportPermissionMap[key] === option.value);
        return userPermissions?.inv_report.per_name_sub_json[permissionKey] === 1;
    });
    setInvoiceReportOptions(invoiceReportOptionsFiltered || [])
    }

  },[userPermissions])

    const reportConfigMap = {
        invoice_summary_report: { endPoint: ORG_INVOICE_SUMMARY_REPORT, requiresClientGroup: false },
        receipt_summary_report: { endPoint: ORG_RECEIPT_SUMMARY_REPORT, requiresClientGroup: false },
        invoice_register_report: { endPoint: ORG_INVOICE_REGISTER_REPORT, requiresClientGroup: true },
        receipt_register_report: { endPoint: ORG_RECEIPT_REGISTER_REPORT, requiresClientGroup: true },
        estimate_register_report: { endPoint: ORG_ESTIMATE_REGISTER_REPORT, requiresClientGroup: true },
        unbilled_task_report: { endPoint: ORG_UNBILLED_TASK_REPORT, requiresClientGroup: false },
        free_task_report: { endPoint: ORG_FREE_TASK_REPORT, requiresClientGroup: false }
    };

    useEffect(() => {
        fetchGroupList();
    }, [])

    const isLeapYear = (year) =>
        (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);

    const validateDateRange = () => {
        // if (!startDate && !endDate) {
        //     setStartDateError("Start date and end date are required.");
        //     setEndDateError("Start date and end date are required.");
        //     return false;
        // }
        if (!startDate) {
            setStartDateError("Start date is required.");
            return false;
        }
        if (!endDate) {
            setEndDateError("End date is required.");
            return false;
        }

        const start = new Date(startDate);
        const end = new Date(endDate);
        if (start > end) {
            setGenerateReportError("Start date cannot be after end date.");
            return false;
        }

        // Include both start and end dates
        const dayDiff = Math.floor((end - start) / (1000 * 60 * 60 * 24)) + 1;
        console.log('dayDiff', dayDiff)

        // Check if Feb 29 exists in range without looping
        const leapDates = [
            new Date(`${start.getFullYear()}-02-29`),
            new Date(`${end.getFullYear()}-02-29`)
        ];
        const includesLeapDay = leapDates.some(
            (date) => date.getDate() === 29 && date.getMonth() === 1 && date >= start && date <= end
        );

        if (dayDiff > (includesLeapDay ? 366 : 365)) {
            setGenerateReportError("Date range should not exceed 365 days. Leap years may allow 366 days.");
            return false;
        }

        return true;
    };

    const handleGenerateReport = async () => {
        setReportNameError('');
        setStartDateError('');
        setEndDateError('');
        setClientError('');
        setGenerateReportError('');
        setGenerateReportSuccess('');

        if (!reportName) {
            setReportNameError("Please select a report type.");
            return;
        }

        if (!validateDateRange()) return;

        var storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
        const config = reportConfigMap[reportName?.value];
        if (!config) {
            setGenerateReportError("Unsupported report type selected.");
            return;
        }

        const payload = {
            emp_id_auth: storedUserInfo?.emp_id,
            report_name: reportName?.value || '',
            start_date: startDate || '',
            end_date: endDate || '',
            ...(config?.requiresClientGroup && {
                client_id: selectedClient?.client_id || 0,
                group_id: groupClient?.value || 0
            })
        };

        console.log('invoice reports payload: ', payload);

        try {
            setGenerateReportLoading(true);
            const response = await postData(config?.endPoint, payload);
            const responseData = await response.json();

            if (response?.status === 200) {
                if (responseData?.status_code === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        if (responseData?.dataJ?.length > 0) {
                            const downloadUrl = responseData?.dataJ[0]?.download_url;
                            // console.log("Download URL:", downloadUrl);
                            if (!downloadUrl) {
                                setGenerateReportError(responseData?.info || 'Excel Not Found'); return
                            }
                            downloadFile(downloadUrl);
                            // resetFilter();
                            setGenerateReportSuccess(responseData?.info);
                            setTimeout(() => {
                                setGenerateReportSuccess('');
                            }, 3000);
                        } else {
                            setGenerateReportError(responseData?.info || 'No records found for the selected date range.');
                            logFrontendException(storedUserId, pageName, `InvoiceReport-${config?.endPoint}`, responseData?.info || '');
                        }
                    } else {
                        setGenerateReportError(responseData?.info || 'Error while downloading report. Please try again.');
                        logFrontendException(storedUserId, pageName, `InvoiceReport-${config?.endPoint}`, responseData?.info || '');
                    }
                } else {
                    setGenerateReportError(responseData?.info || 'Failed to download report.');
                    logFrontendException(storedUserId, pageName, `InvoiceReport-${config?.endPoint}`, responseData || '');
                }
            } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                setGenerateReportError("Unauthorized access. Your session may have expired. Please log in again.");
                setIsLoginPopup(true);
            } else {
                setGenerateReportError(responseData?.info || "Failed to download report. Please try again.");
                logFrontendException(storedUserId, pageName, `InvoiceReport-${config?.endPoint}`, response || '');
            }
        } catch (error) {
            console.log('handleGenerateReport catch error', error)
            setGenerateReportError("Failed to download report. Please check your network connection and try again.");
            logFrontendException(storedUserId, pageName, `InvoiceReport-${config?.endPoint}`, error);
        } finally {
            setGenerateReportLoading(false);
        }
    };

    const downloadFile = (url) => {
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Report.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const resetFilter = () => {
        setReportName(null); setReportNameError('');
        setStartDate(''); setStartDateError('');
        setEndDate(''); setEndDateError('')
        setSelectedClient(null); setSearchClient(null); setClientSearchError(''); setClientError('');
        setGenerateReportError('');
        // setGroupClient(null);
    }

    const requiresClientGroup = [
        "invoice_register_report", "receipt_register_report", "estimate_register_report"
    ].includes(reportName?.value);

    const handleStartDateChange = (value) => {
        console.log('handleStartDateChange value', value);
        setStartDate(value);
        setStartDateError('');
        setGenerateReportError('');
    };

    const handleEndDateChange = (value) => {
        console.log('handleEndDateChange value', value);
        setEndDate(value);
        setEndDateError('');
        setGenerateReportError('');
    };

    const handleSearchClient = async () => {

        try {
            setClientError('');
            setClientSearchError('');
            if (!searchClient?.trim()) {
                setClientSearchError('Please enter valid text'); return;
            }
            setClientListLoading(true);
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payLoad = { emp_id_auth: storedUserInfo?.emp_id, search_type: "GENERIC", search_word: searchClient }

            //console.log('handleSearchClient payload', payLoad);
            // Make the API call
            const response = await postData(ORG_CLIENT_SEARCH_TO_ADD_GROUPMEMBER, payLoad);
            const responseData = await response.json();
            //console.log('response Data', responseData);

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        // setAddEmployeeError('')
                        setClientList(responseData?.dataJ || []);
                        //   setClientError(responseData?.info);
                        setTimeout(() => {
                            // handleClose();
                            // onValueChange();
                        }, 2000);
                    } else {
                        setClientError(responseData?.info || 'Failed to fetch client data. Please try again.');
                        logFrontendException(storedUserId, pageName, "handleSearchClient", responseData?.info || '');
                    }
                } else {
                    setClientError(responseData?.info || 'Failed to fetch client data.');
                    logFrontendException(storedUserId, pageName, "handleSearchClient", responseData?.info || '');
                }
            }
            else {
                setClientError('Unexpected error occurred. Please try again later.');
                logFrontendException(storedUserId, pageName, "handleSearchClient", response || '');
            }
        } catch (error) {
            // An error occurred in setting up the request
            setClientError(`Failed to fetch client data. Please check your network connection and try again.`);
            logFrontendException(storedUserId, pageName, "handleSearchClient-catch", error || '');

        } finally {
            setClientListLoading(false);
        }
    };

    const handleSearchInputChange = (value) => {
        setSearchClient(value);
        if (value.trim().length > 0) {
            setClientError('');
        }
        // setClientSearchError('');
        setGroupClient(null);
        setSelectedClient(null);
        setClientList([])
    }
    const handleSelectedClient = (employee) => {
        setSelectedClient(employee);
        setSearchClient(employee?.client_name);

        setClientList([]); // Clear the dropdown
    };

    const handleReportName = (selected) => {
        setReportName(selected);
        setReportNameError('');
        setSearchClient(null); setSelectedClient(null);
        setGroupClient(null);
        setGenerateReportError('');
        setStartDate(''); setClientSearchError(''); setClientError('');
        setEndDate('');
        setStartDateError(''); setEndDateError('');

    }

    const fetchGroupList = async () => {
        try {
            setGroupClientError('')
            setGroupLoading(true);
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

            // Make the API call
            const response = await getData(`${ORG_GET_GROUP_LIST}?emp_id_auth=${storedUserInfo?.emp_id}`);
            const responseData = await response.json();

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        if (responseData?.dataJ?.length > 0) {
                            // Transforming the data
                            const filterData = responseData?.dataJ.map(service => ({
                                label: service.group_name,
                                value: service.group_id
                            }));
                            setGroupClientOptionsList(filterData)
                        } else {
                            setGroupClientError(responseData?.info || 'No groups available.');
                            logFrontendException(storedUserId, pageName, "fetchGroups", responseData?.info || '');
                        }
                    } else {
                        setGroupClientError(responseData?.info || 'Error while fetching group list.');
                        logFrontendException(storedUserId, pageName, "fetchGroups", responseData?.info || '');
                    }
                } else {
                    setGroupClientError(responseData?.info || 'Failed to fetch group list.');
                    logFrontendException(storedUserId, pageName, "fetchGroups", responseData?.info || '');
                }
            } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                setGroupClientError('Unauthorized access. Your session may have expired. Please log in again.');
                logFrontendException(storedUserId, pageName, "fetchGroups", response || '');
                setIsLoginPopup(true)

            } else {
                setGroupClientError('Failed to fetch group list. Please try again.');
                logFrontendException(storedUserId, pageName, "fetchGroups", response || '');
            }
        } catch (error) {
            setGroupClientError(`Failed to fetch group list. Please check your network connection and try again.`);
            logFrontendException(storedUserId, pageName, "fetchGroups-catch", error || '');
        } finally {
            setGroupLoading(false);
        }
    }

    return {
        reportName, handleReportName, invoiceReportOptions,
        startDate, setStartDate, startDateError, handleStartDateChange,
        endDate, setEndDate, endDateError, handleEndDateChange,
        generateReportSuccess, generateReportError, generateReportLoading,
        handleSearchClient, clientListLoading, clientSearchError, clientList,
        clientError, handleSearchInputChange, handleSelectedClient,
        searchClient, handleGenerateReport, resetFilter, reportNameError,
        groupClient, setGroupClient, requiresClientGroup,
        groupClientOptionsList, groupLoading, groupClientError
    };
};

export default InvoiceReportsController;
